<div class="px-10 pt-6 pb-10">
  <div class="flex items-center justify-between mb-6">
    <div class="flex flex-col gap-1">
      <h1 class="text-2xl font-bold text-primary-dark">Configurações do Sistema</h1>
    </div>

    <button
      type="button"
      class="px-5 py-2.5 rounded-lg font-medium text-white bg-primary disabled:opacity-60 disabled:cursor-not-allowed"
      [disabled]="!hasPendingChanges() || isSaving || isLoading"
      (click)="saveChanges()"
    >
      {{ isSaving ? "Salvando..." : "Salvar Alterações" }}
    </button>
  </div>

  <div *ngIf="isLoading" class="py-16 flex justify-center">
    <p class="text-primary-gray">Carregando configurações...</p>
  </div>

  <form *ngIf="!isLoading" [formGroup]="form" class="flex flex-col gap-6">
    <div class="bg-white border-0 rounded-lg shadow-sm">
      <div class="p-6">
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <div class="px-3 rounded-lg bg-blue-50 flex items-center justify-center mr-3.5 flex-shrink-0">
              <mat-icon class="text-primary">calendar_month</mat-icon>
            </div>
            <div class="flex-1">
              <h3 class="text-base font-semibold text-gray-800">Feriados do Sistema</h3>
              <p class="text-sm text-gray-600 mt-0.5">Gerencie os feriados utilizados no planejamento de rotas e visitas</p>
            </div>
          </div>

          <div>
            <button
              type="button"
              class="text-primary font-semibold text-sm px-3 py-2 rounded-lg hover:bg-blue-50 transition-colors"
              (click)="openHolidayManagement()"
            >
              Gerenciar Feriados ->
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white border-0 rounded-lg shadow-sm">
      <div class="p-6">
        <div class="flex items-start gap-3 mb-3">
          <div class="px-3 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-primary">inventory_2</mat-icon>
          </div>
          <div>
            <h3 class="text-base font-semibold text-gray-800">Processamento de Informações</h3>
            <p class="text-sm text-gray-600 mt-0.5">Gerencie as informações de clientes que serão processadas por IA para exibição no perfil</p>
          </div>
        </div>

        <div formArrayName="processingCards" class="processing-cards-container">
          <div
            *ngFor="let cardControl of processingCardsArray.controls; let cardIndex = index; trackBy: trackCard"
            [formGroupName]="cardIndex"
            class="processing-card"
          >
            <button
              type="button"
              class="processing-delete-button"
              aria-label="Excluir informação"
              (click)="removeInformationCard(cardIndex, $event)"
            >
              <mat-icon>close</mat-icon>
            </button>

            <div class="flex flex-col gap-3">
              <div class="flex flex-col xl:flex-row gap-3">
                <div class="flex-1 min-w-[120px]">
                  <label class="input-label">Título da Informação <span class="text-red-600">*</span></label>
                  <input
                    type="text"
                    formControlName="title"
                    class="w-full border rounded-lg px-3 py-2.5 bg-white input-field-focus"
                    [class.border-red-500]="isControlInvalid(cardControl.get('title'))"
                    placeholder="Digite o título"
                  />
                  <p *ngIf="isControlInvalid(cardControl.get('title'))" class="mt-1 text-xs text-red-600">
                    Informe um título válido (máximo 200 caracteres).
                  </p>
                </div>

                <div class="w-full xl:w-[220px]">
                  <label class="input-label">Tipo da Informação <span class="text-red-600">*</span></label>
                  <select
                    formControlName="type"
                    class="w-full border rounded-lg px-3 py-2.5 bg-white input-field-focus"
                    [class.border-red-500]="isControlInvalid(cardControl.get('type'))"
                  >
                    <option *ngFor="let option of informationTypeOptions" [ngValue]="option.value">{{ option.label }}</option>
                  </select>
                </div>

                <div class="w-full xl:w-[280px]">
                  <label class="input-label">Formulário-Base <span class="text-red-600">*</span></label>
                  <select
                    formControlName="dynamicFormId"
                    class="w-full border rounded-lg px-3 py-2.5 bg-white input-field-focus"
                    [class.border-red-500]="isControlInvalid(cardControl.get('dynamicFormId'))"
                  >
                    <option [ngValue]="null">Selecione um formulário</option>
                    <option *ngFor="let formOption of formBaseOptions" [ngValue]="formOption.id">{{ formOption.title }}</option>
                  </select>
                  <p *ngIf="isControlInvalid(cardControl.get('dynamicFormId'))" class="mt-1 text-xs text-red-600">
                    Selecione um formulário-base.
                  </p>
                </div>
              </div>

              <div>
                <label class="input-label">Pergunta(s) para Processamento <span class="text-red-600">*</span></label>
                <ng-select
                  formControlName="dynamicFormQuestionIds"
                  [items]="getCardQuestionOptions(cardControl)"
                  bindLabel="text"
                  bindValue="id"
                  [multiple]="true"
                  [searchable]="true"
                  [closeOnSelect]="false"
                  [clearable]="true"
                  [loading]="isCardQuestionsLoading(cardControl)"
                  [hideSelected]="true"
                  placeholder="Selecione as perguntas"
                  notFoundText="Nenhuma pergunta disponível"
                  loadingText="Carregando perguntas..."
                  class="processing-questions-select"
                  [ngClass]="{ 'ng-select-invalid': isControlInvalid(cardControl.get('dynamicFormQuestionIds')) }"
                >
                </ng-select>
                <p *ngIf="isControlInvalid(cardControl.get('dynamicFormQuestionIds'))" class="mt-1 text-xs text-red-600">
                  Selecione ao menos uma pergunta para processamento.
                </p>
              </div>

              <div>
                <label class="input-label">Instruções da Informação para a IA <span class="text-red-600">*</span></label>
                <textarea
                  formControlName="instruction"
                  rows="4"
                  class="w-full border rounded-lg px-3 py-2.5 bg-white input-field-focus resize-y min-h-[120px]"
                  [class.border-red-500]="isControlInvalid(cardControl.get('instruction'))"
                  placeholder="Digite o prompt que será enviado para a IA junto com as respostas selecionadas"
                ></textarea>
                <p *ngIf="isControlInvalid(cardControl.get('instruction'))" class="mt-1 text-xs text-red-600">
                  Informe as instruções da informação para a IA.
                </p>
              </div>

              <div *ngIf="isAlternativeCard(cardControl)" class="flex flex-col gap-3">
                <div
                  formArrayName="options"
                  class="processing-options-wrapper"
                  [class.processing-options-collapsed]="shouldShowExpandToggle(cardControl) && !isCardExpanded(cardControl)"
                >
                  <div class="processing-options-list">
                    <div
                      *ngFor="let optionIndex of getVisibleOptionIndexes(cardControl); trackBy: trackByIndex"
                      [formGroupName]="optionIndex"
                      class="processing-option-row"
                    >
                      <button
                        type="button"
                        class="processing-option-delete"
                        aria-label="Excluir opção"
                        (click)="removeOption(cardControl, optionIndex)"
                      >
                        <mat-icon>close</mat-icon>
                      </button>

                      <div class="flex flex-col xl:flex-row gap-3">
                        <div class="flex-1 min-w-[220px]">
                          <label class="input-label">Opção <span class="text-red-600">*</span></label>
                          <input
                            type="text"
                            formControlName="label"
                            class="w-full border rounded-lg px-3 py-2.5 bg-white input-field-focus"
                            [class.border-red-500]="isControlInvalid(getOptionControl(cardControl, optionIndex, 'label'))"
                            placeholder="Digite a opção"
                          />
                          <p
                            *ngIf="isControlInvalid(getOptionControl(cardControl, optionIndex, 'label'))"
                            class="mt-1 text-xs text-red-600"
                          >
                            Informe um texto válido para a opção (máximo 120 caracteres).
                          </p>
                        </div>

                        <div class="w-full xl:w-[260px]">
                          <label class="input-label">Cor de Exibição <span class="text-red-600">*</span></label>
                          <select
                            formControlName="color"
                            class="w-full border rounded-lg px-3 py-2.5 bg-white input-field-focus"
                            [class.border-red-500]="isControlInvalid(getOptionControl(cardControl, optionIndex, 'color'))"
                          >
                            <option *ngFor="let colorOption of informationColorOptions" [ngValue]="colorOption.value">
                              {{ colorOption.label }}
                            </option>
                          </select>
                          <p class="mt-1 text-xs text-gray-500">
                            <span
                              class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold"
                              [ngClass]="getColorOptionClass(getOptionControl(cardControl, optionIndex, 'color')?.value)"
                            >
                              {{ getColorOptionLabel(getOptionControl(cardControl, optionIndex, 'color')?.value) }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="shouldShowExpandToggle(cardControl) && !isCardExpanded(cardControl)"
                    class="processing-options-fade"
                  ></div>
                </div>

                <p *ngIf="cardControl.get('options')?.hasError('requiredOptions')" class="text-xs text-red-600">
                  Adicione ao menos uma opção para informações do tipo Alternativas.
                </p>
                <p *ngIf="cardControl.get('options')?.hasError('duplicatedLabels')" class="text-xs text-red-600">
                  As opções não podem ter nomes repetidos.
                </p>

                <div class="flex items-center gap-2 flex-wrap">
                  <button
                    type="button"
                    class="rounded-lg bg-primary text-white px-4 py-2 text-sm font-medium hover:opacity-95"
                    (click)="addOption(cardControl)"
                  >
                    + Adicionar Opção
                  </button>
                </div>

                <div *ngIf="shouldShowExpandToggle(cardControl)" class="processing-expand-toggle-wrapper">
                  <button
                    type="button"
                    class="processing-expand-toggle"
                    (click)="toggleCardExpand(cardControl)"
                  >
                    <mat-icon>{{ isCardExpanded(cardControl) ? "expand_less" : "expand_more" }}</mat-icon>
                    {{ isCardExpanded(cardControl) ? "Ver Menos" : "Ver Mais" }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="self-start w-auto rounded-lg bg-primary text-white px-4 py-2 text-sm font-medium inline-flex items-center gap-2 hover:opacity-95"
            (click)="addInformationCard()"
          >
            <mat-icon>add</mat-icon>
            <span>Adicionar Informação</span>
          </button>

          <p *ngIf="hasDuplicateSavedCardIds" class="text-xs text-red-600">
            Existem cards salvos com IDs duplicados no estado atual. Recarregue a página e tente novamente.
          </p>
        </div>
      </div>
    </div>

    <app-section-card
      icon="/assets/icons/section/notifications.svg"
      title="Notificações do Sistema"
      description="Ative ou desative cada tipo de alerta enviado para a Central de Notificações"
    >
      <div class="flex flex-col">
        <div
          *ngFor="let rule of notificationRules; let isLast = last"
          class="flex items-center justify-between gap-4 p-3 mb-4 bg-gray-50 rounded"
          [class.border-b]="!isLast"
          [class.border-gray-100]="!isLast"
        >
          <div class="flex items-start gap-3 min-w-0">
            <div class="w-9 h-9 flex items-center justify-center flex-shrink-0">
              <mat-icon class="text-[20px]">{{ rule.icon }}</mat-icon>
            </div>

            <div class="min-w-0">
              <p class="text-sm font-semibold text-primary-dark">{{ rule.name }}</p>
              <p class="text-xs text-primary-gray mt-1">{{ rule.resolvedDescription }}</p>
            </div>
          </div>

          <div class="flex items-center gap-3 flex-shrink-0">
            <button
              type="button"
              class="px-3 py-2 rounded-lg text-sm font-medium text-primary-gray hover:bg-gray-100 transition-colors"
              (click)="openEditTemplate(rule)"
            >
              Editar texto
            </button>

            <app-custom-toggle [checked]="rule.isEnabled" (checkedChange)="onRuleToggle(rule.type, $event)"></app-custom-toggle>
          </div>
        </div>
      </div>
    </app-section-card>
  </form>
</div>
